/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import {
    RejectedTraffic,
    RejectedTrafficAdd,
    RejectedTrafficChange,
    RejectedTrafficFilter,
    RejectedTrafficInfo,
    RejectedTrafficRuleType,
} from 'models/api/rejectedTraffic';
import Table from 'models/api/table';
import { Key } from 'react';

export const getRejectedTraffic = async (
    axios: AxiosInstance,
    requestParams: RejectedTrafficFilter
) => {
    const response = await axios.get<Table<RejectedTraffic>>('/rejectedTraffic', {
        params: requestParams,
    });
    return response.data;
};

export const getRejectedTrafficItem = async (axios: AxiosInstance, id: Key) => {
    const response = await axios.get<RejectedTrafficInfo>(`/rejectedTraffic/${id}`);
    return response.data;
};

export const getRejectedTrafficRules = async (axios: AxiosInstance) => {
    const response = await axios.get<RejectedTrafficRuleType[]>(`/rejectedTraffic/rules`);
    return response.data;
};

export const addRejectedTrafficItem = async (axios: AxiosInstance, info: RejectedTrafficAdd) => {
    const response = await axios.post('/rejectedTraffic', info);
    return response.data;
};

export const updateRejectedTrafficItem = async (
    axios: AxiosInstance,
    info: RejectedTrafficChange
) => {
    const response = await axios.put(`/rejectedTraffic/${info.id}`, info);
    return response.data;
};

export const deleteRejectedTrafficItem = async (axios: AxiosInstance, id: Key) => {
    const response = await axios.delete(`/rejectedTraffic/${id}`);
    return response.data;
};

export const getRejectedTrafficExcel = async (
    axios: AxiosInstance,
    requestParams: RejectedTrafficFilter
) => {
    const { data } = await axios.get<Blob>('/rejectedTraffic/excel', {
        responseType: 'arraybuffer',
        params: { ...requestParams },
    });
    return data;
};
